import React, { useEffect, useState } from "react"
import { getRoutesQuery, getLangFromPath } from "src/utils"
import { useLocation } from "@reach/router"
import { getRoutesArray } from "src/utils"
import { TransitionProvider, TransitionViews } from "gatsby-plugin-transitions"
import BazierEasing from "bezier-easing"

import Header from "src/components/mobile/_layout/header"
import ProgressBar from "src/components/mobile/_layout/progressBar"
import GlobalStyle, { ChapterTitle, Main } from "./styles"

const Layout = ({ children }) => {
  const [routes, setRoutes] = useState(null)
  const [currentRoute, setCurrentRoute] = useState(null)
  const { chapter } = getRoutesQuery()
  let { pathname } = useLocation()
  const location = useLocation()
  const lang = getLangFromPath()

  useEffect(() => {
    const routes = getRoutesArray(chapter, lang)
    if (!routes) return
    setRoutes([...routes])

    routes.forEach((r, ix) => {
      if (r.route.content === pathname || r.route.content === pathname + "/") {
        setCurrentRoute({
          title: r.name.content,
          url: r.route.content,
        })
      }
    })
  }, [lang, chapter, pathname])

  const notLanding = pathname.split("/").length > 3

  return (
    <>
      <GlobalStyle />
      {notLanding && (
        <>
          <Header routes={routes} currentRoute={currentRoute} />
          <ChapterTitle>{currentRoute?.title}</ChapterTitle>
          <ProgressBar />
        </>
      )}
      <TransitionProvider
        location={location}
        mode="immediate"
        enter={{
          opacity: 1,
          transform: "translate3d(0,0.1vh,0) scale3d(1, 1, 1) rotate(0deg)",
          config: {
            duration: 1000,
          },
        }}
        usual={{
          opacity: 1,
          transform: "translate3d(0vh,0vh,0) scale3d(1, 1, 1) rotate(0deg)",
        }}
        leave={{
          opacity: 1,
          transform: "translate3d(0vh,-100vh,0) scale3d(1, 1, 1) rotate(0deg)",
          config: {
            mass: 1,
            tension: 220,
            clamp: true,
            duration: 1000,
            easing: t => BazierEasing(0.82, 0.0, 0.195, 1.0)(t),
          },
        }}
      >
        <Main style={notLanding ? null : { padding: 0 }}>
          <TransitionViews>{children}</TransitionViews>
        </Main>
      </TransitionProvider>
    </>
  )
}

export default Layout
